import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { Route, useLocation } from "react-router-dom";
import { CSSTransition } from "react-transition-group";

import { AppTopbar } from "../AppTopbar";
import { AppMenu } from "../AppMenu";
import { AppConfig } from "../AppConfig";

import Bitacora from "../pages/Catalogos/Bitacora/Bitacora";
import CatalogoClientes from "../pages/Catalogos/Clientes/CatalogoClientes";
// import CatalogoLicencias from "../pages/Catalogos/Licencias/CatalogoLicencias";
import ConfigLicencias from "../pages/Catalogos/Licencias/ConfigLicencias";
import CatalogoPaquetes from "../pages/Catalogos/Paquetes/CatalogoPaquetes";
import CatalogoUsuarios from "../pages/Catalogos/Usuarios/CatalogoUsuarios";

import PrimeReact from "primereact/api";
import { Tooltip } from "primereact/tooltip";
import { useHistory } from 'react-router-dom';
import jwt from 'jsonwebtoken';

import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "../assets/demo/flags/flags.css";
import "../assets/demo/Demos.scss";
import "../assets/layout/layout.scss";
import "../App.scss";

const Home = ({ setLogueado }) => {
    let history = useHistory();

    const [layoutMode, setLayoutMode] = useState("static");
    const [layoutColorMode, setLayoutColorMode] = useState("light");
    const [inputStyle, setInputStyle] = useState("outlined");
    const [ripple, setRipple] = useState(true);
    const [staticMenuInactive, setStaticMenuInactive] = useState(false);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
    const copyTooltipRef = useRef();
    const location = useLocation();

    PrimeReact.ripple = true;

    let menuClick = false;
    let mobileTopbarMenuClick = false;

    useEffect(() => {
        if (mobileMenuActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }
    }, [mobileMenuActive]);

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    };

    const onRipple = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onLayoutModeChange = (mode) => { setLayoutMode(mode) }

    const onColorModeChange = (mode) => { setLayoutColorMode(mode) }

    const onWrapperClick = (event) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }

        if (!mobileTopbarMenuClick) {
            setMobileTopbarMenuActive(false);
        }

        mobileTopbarMenuClick = false;
        menuClick = false;
    };

    const onToggleMenuClick = (event) => {
        menuClick = true;

        if (isDesktop()) {
            if (layoutMode === "overlay") {
                if (mobileMenuActive === true) {
                    setOverlayMenuActive(true);
                }

                setOverlayMenuActive((prevState) => !prevState);
                setMobileMenuActive(false);
            } else if (layoutMode === "static") {
                setStaticMenuInactive((prevState) => !prevState);
            }
        } else {
            setMobileMenuActive((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const onSidebarClick = () => { menuClick = true }

    const onMobileTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        setMobileTopbarMenuActive((prevState) => !prevState);
        event.preventDefault();
    };

    const onMobileSubTopbarMenuClick = (event) => {
        event.preventDefault();
        mobileTopbarMenuClick = true;
        // localStorage.removeItem('logueado')     // Eliminar valor para terminar sesion
        // setLogueado(false)                      // Cerrar sesion
        // console.log("Termino la sesion")    
    };

    const cerrarSesion = () => {
        localStorage.removeItem('tokenAdmin')     // Eliminar valor para terminar sesion
        setLogueado(false)                      // Cerrar sesion
        history.push("/")                       // Redireccionar a login
    }

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
    };
    const isDesktop = () => { return window.innerWidth >= 992 }

    const [usuario, setUsuario] = useState('');
    useEffect(() => {
        try {
            const decodedToken = jwt.decode(localStorage.getItem('tokenAdmin'));
            // Obtener el "subject" del payload
            const subject = decodedToken.sub;
            setUsuario(subject);
        } catch (error) {
            console.log(error);
        }
    }, []);

    const menu = [
        {
            label: "",
            items: [
                { label: usuario, icon: "pi pi-user" },
            ],
        },
        {
            label: "Administrador",
            items: [
                { label: "Bitácora", icon: "pi pi-fw pi-table text-blue-500", to: "/bitacora" },
                { label: "Clientes", icon: "pi pi-fw pi-table text-blue-500", to: "/catalogoClientes" },
                { label: "Usuarios", icon: "pi pi-fw pi-table text-blue-500", to: "/catalogoUsuarios" },
            ],
        },
    ];

    const addClass = (element, className) => {
        if (element.classList) element.classList.add(className);
        else element.className += " " + className;
    };

    const removeClass = (element, className) => {
        if (element.classList) element.classList.remove(className);
        else element.className = element.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    };

    const wrapperClass = classNames("layout-wrapper", {
        "layout-overlay": layoutMode === "overlay",
        "layout-static": layoutMode === "static",
        "layout-static-sidebar-inactive": staticMenuInactive && layoutMode === "static",
        "layout-overlay-sidebar-active": overlayMenuActive && layoutMode === "overlay",
        "layout-mobile-sidebar-active": mobileMenuActive,
        "p-input-filled": inputStyle === "filled",
        "p-ripple-disabled": ripple === false,
        "layout-theme-light": layoutColorMode === "light",
    });

    //--------------------| Valor que regresara  |--------------------
    return (
        <div className={wrapperClass} onClick={onWrapperClick}>
            {/* <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" /> */}

            <AppTopbar
                onToggleMenuClick={onToggleMenuClick}
                layoutColorMode={layoutColorMode}
                mobileTopbarMenuActive={mobileTopbarMenuActive}
                onMobileTopbarMenuClick={onMobileTopbarMenuClick}
                onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick}
                cerrarSesion={cerrarSesion}
            />

            {/* Barra de navegacion */}
            <div className="layout-sidebar" onClick={onSidebarClick}>
                <AppMenu model={menu} onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode} />
            </div>

            <div className="layout-main-container mt-0">
                <div className="layout-main">
                    <Route path="/" exact render={() => <Bitacora />} />
                    <Route path="/bitacora" component={Bitacora} />
                    <Route path="/catalogoClientes" component={CatalogoClientes} />
                    <Route path="/catalogoPaquetes" component={CatalogoPaquetes} />
                    <Route path="/catalogoUsuarios" component={CatalogoUsuarios} />
                    <Route path="/configLicenciaFromCliente/:id" component={ConfigLicencias} />
                    <Route path="/configLicencia" component={ConfigLicencias} />
                </div>
            </div>

            {/* <AppConfig rippleEffect={ripple} onRippleEffect={onRipple} inputStyle={inputStyle} onInputStyleChange={onInputStyleChange} layoutMode={layoutMode} onLayoutModeChange={onLayoutModeChange} layoutColorMode={layoutColorMode} onColorModeChange={onColorModeChange} /> */}

            <CSSTransition classNames="layout-mask" timeout={{ enter: 200, exit: 200 }} in={mobileMenuActive} unmountOnExit>
                <div className="layout-mask p-component-overlay"></div>
            </CSSTransition>
        </div>
    );
};

export default Home;
